import { CREDIT_SLIP_ACTION, CREDIT_SLIP_ACTION_LOADER } from "../type";

const initialState = {
    loader: false,
    data: [],
    error: null
};
const CreditSlipReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREDIT_SLIP_ACTION_LOADER: {
            return { ...state, loader: action.loader };
        }
        case CREDIT_SLIP_ACTION: {
            return { ...state, data: action.data, error: action.error };
        }
        default: {
            return state;
        }
    }
};

export default CreditSlipReducer;